export default {"src":"/_next/static/media/trustpilot-logo.2f8a25db.svg","height":28,"width":115,"blurWidth":0,"blurHeight":0};